import http from "./httpService";
import moment from "moment";


const apiEndpoint = process.env.REACT_APP_API_PROSPECTSALESTOOL_URL + "/UploadContent";

export async function GetUserGroupData() {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/userGroup");
}

export async function GetSections() {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/sections");
}

export async function GetContentLibraryGridData(market_id, section_id) {
  const request = {
    screen: "ContentLibrary",
    action: "View",
    user_id: localStorage.getItem('user_id'),
    section_id: section_id,
    market_id: market_id
  }
  http.addBearerAuthorization();
  return await http.post(apiEndpoint + "/", request);
}
export async function GetContentCardMembers(request){
 
  http.addBearerAuthorization();
  return await http.post(apiEndpoint + "/contentview", request);
}
export async function GetContentTypes() {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/contentType");
}

export async function GetIcons() {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/icons");
}

export async function SaveContent(request) {
  var formData = new FormData();
  formData.append("screen", request.screen);
  formData.append("action", request.action);
  formData.append("user_id", request.user_id);
  formData.append("market_id", request.market_id);
  formData.append("group_id", request.user_group);
  formData.append("section_id", request.section_id);
  formData.append("topic", request.topic);
  formData.append("icon_id", request.icon_id);
  formData.append("visibilityStartDate",  moment(`${request.visibilityStartDate} ${request.startTime?request.startTime:'12:00 am'}`).utc().format('DD-MM-YYYY HH:mm:ss'));
  if(request.visibilityEndDate!=""){

    formData.append("visibilityEndDate",  moment(`${request.visibilityEndDate} ${request.endTime?request.endTime:'12:00 pm'}`).utc().format('DD-MM-YYYY HH:mm:ss'));
  }else{
    formData.append("visibilityEndDate", request.visibilityEndDate );
  }
  formData.append("type_id", request.type_id);
  formData.append("content", request.content);
  formData.append("file_content", request.file_content);
  http.addBearerAuthorization();
  return await http.post(apiEndpoint + "/save", formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export async function GetContentDetails(request) {
  http.addBearerAuthorization();
  return await http.post(apiEndpoint + "/output", request);
}

export async function DeleteContent(id,section,screen,action,market_id,section_id,user_id) {    
  const request = {
    content_id: id,
    section: section,
    screen: screen,
    action: action,
    user_id: user_id,
    section_id: section_id,
    market_id: market_id
  }
  http.addBearerAuthorization();
  return await http.post(apiEndpoint + "/delete", request);
}

export async function GetEditContent(content_id,user_id,screen,action) {      
  const request = {
    content_id: content_id,
    screen: screen,
    action: action,
    user_id: user_id
  }
  http.addBearerAuthorization();
  return await http.post(apiEndpoint + "/geteditcontent", request);
}

export async function EditContent(request) {

  var formData = new FormData();
  formData.append("screen", request.screen);
  formData.append("action", request.action);
  formData.append("content_id", request.content_id);
  formData.append("user_id", request.user_id);
  formData.append("market_id", request.market_id);
  formData.append("group_id", request.user_group);
  formData.append("section_id", request.section_id);
  formData.append("topic", request.topic);
  formData.append("icon_id", request.icon_id);
  formData.append("visibilityStartDate",  moment(`${request.visibilityStartDate} ${request.startTime?request.startTime:'12:00 am'}`).utc().format('DD-MM-YYYY HH:mm'));


  if(request.visibilityEndDate!=""){

    formData.append("visibilityEndDate",  moment(`${request.visibilityEndDate} ${request.endTime?request.endTime:'12:00 pm'}`).utc().format('DD-MM-YYYY HH:mm'));

  }else{
    formData.append("visibilityEndDate", request.visibilityEndDate );
  }
  formData.append("type_id", request.type_id);
  formData.append("content", request.content);
  formData.append("file_content", request.file_content);
  http.addBearerAuthorization();
  return await http.post(apiEndpoint + "/edit", formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export default {
  GetUserGroupData,
  GetSections,
  GetContentLibraryGridData,
  GetContentTypes,
  GetIcons,
  SaveContent,
  GetContentDetails,
  GetContentCardMembers,
  DeleteContent,
  GetEditContent,
  EditContent
};
